import React from 'react';
import { Skeleton } from 'antd';

export default function ManagementTableSkeleton({ rows = 7 }) {
   return (
      <div className="management-loading-state" role="status" aria-live="polite">
         <div className="management-skeleton-table" aria-label="Loading records">
            <div className="management-skeleton-header">
               <Skeleton.Input active size="small" className="management-skeleton-title" />
               <Skeleton.Input active size="small" className="management-skeleton-chip" />
            </div>
            {Array.from({ length: rows }).map((_, index) => (
               <div className="management-skeleton-row" key={`management-skeleton-${index}`}>
                  <Skeleton.Input active size="small" className="management-skeleton-cell is-wide" />
                  <Skeleton.Input active size="small" className="management-skeleton-cell" />
                  <Skeleton.Input active size="small" className="management-skeleton-cell" />
                  <Skeleton.Button active size="small" shape="round" className="management-skeleton-action" />
               </div>
            ))}
         </div>
      </div>
   );
}
